import type { ReactNode } from "react";

import "./model/sync-session";
import "./model/update-session";

type Props = {
  children: ReactNode;
};

export const AuthenticationProvider = ({ children }: Props) => {
  return <>{children}</>;
};
